<template>
  <div>
    <div class="flex-gt-sm-100 flex-100 px-2">

      <!-- hidden input field to show error, if element of op complications is empty -->

      <validation-provider tag="div"
                           :name="path"
                           :ref="path"
                           :rules="{required:true,at_least_one_complication_is_selected: [model.komplikation_nein_oder_unbekannt, model.kuerzel, model.icd]}"
                           v-slot="{ errors }">
        <lx-alert-box v-show="errors[0]" color="red" class="mb-3">
          {{ errors[0] }}
        </lx-alert-box>

        <v-text-field
          v-model="model"
          v-show="false"
          :error-messages="errors[0]"
        ></v-text-field>
      </validation-provider>
    </div>

    <!-- komplikation_nein_oder_unbekannt -->

    <div class="flex-100 px-2 mb-4">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_OP_COMPLICATIONS_EXIST')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.komplikation_nein_oder_unbekannt'"
                             :ref="path + '.komplikation_nein_oder_unbekannt'"
                             rules=""
                             v-slot="{ errors }">

          <div class="layout-column px-4 pb-4 pt-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.komplikation_nein_oder_unbekannt" row :error-messages="errors[0]" hide-details class="ma-0 pa-0"
                           style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO')"
                       @change="resetComplicationTypes(model.komplikation_nein_oder_unbekannt)"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.UNKNOWN')"
                       @change="resetComplicationTypes(model.komplikation_nein_oder_unbekannt)"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of done via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center"
                     @click="resetRadioButtons('komplikation_nein_oder_unbekannt')"
                     v-show="model.komplikation_nein_oder_unbekannt && !isDisabled"
                     :disabled="!model.komplikation_nein_oder_unbekannt && !isDisabled"
                     style="max-height:24px;"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <div class="flex-100 px-2 mb-4">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_OP_COMPLICATIONS_YES')"
                        :disabled="isDisabled">

        <!-- List of accessible complications to select -->

        <div class="layout-column flex-100 px-4 mt-2">
          <v-autocomplete
            :color="compColor.primeColor"
            v-model="selectedComplicationType"
            outlined
            class="mb-3"
            :dense="denseFields"
            :disabled="isDisabled || !!model.komplikation_nein_oder_unbekannt"
            hide-details
            @input="addKuerzel(selectedComplicationType)"
            :label="$t('FORMS_DIVERSE.MODULE_OP_COMPLICATIONS_COMPLICATION') + ' *'"
            :dark="compColor.isInDarkMode"
            :items="OP_KomplikationTypes"
          >
            <template v-slot:no-data>
              <div class="layout-row pt-1 pb-1 pl-3 pr-3">
                <div class="flex layout-row mr-3 lighten-4 text--darken-2"
                     :class="compColor.isInDarkMode ? ['white--text'] : []"
                     :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                  {{ $t('NO_SEARCH_RESULT') }}
                </div>
              </div>
            </template>

            <template v-slot:item="{ item, on, parent}">
              <v-list-item v-on="on"
                           :class="compColor.isInDarkMode?['blue-grey darken-4'] : []">
                <v-list-item-content class="py-0 layout-row">
                  <div class="py-0 layout-row"
                       :class="compColor.isInDarkMode ? ['white--text'] : []"
                       :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                    <lx-text-highlight :text="item.text" :search-string="parent._props.searchInput"
                                       :color="compColor.prime"></lx-text-highlight>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </div>

        <!-- Hidden input field of complications to trigger dirty-flag for auto-save -->

        <div>
          <validation-provider tag="div"
                               :name="path + '.kuerzel'"
                               :ref="path + '.kuerzel'"
                               rules=""
                               v-slot="{}">
            <v-text-field
              v-model="model.kuerzel"
              v-show="false"
              dense
              outlined
              hide-details
            ></v-text-field>
          </validation-provider>
        </div>

        <!-- Items -->

        <div class="px-2 pt-2 mb-3 mx-4 layout-row rounded layout-wrap" v-if="Object.keys(model.kuerzel).length > 0" :style="{'background': isDarkMode ? 'rgba(255,255,255,0.15)':'#EEEEEE'}">
          <div class="layout-row layout-wrap flex">
            <div v-for="(item, index) in model.kuerzel" :key="index" class=" body-2 lighten-4 text--darken-2 mr-2 mb-2 rounded" :class="[compColor.prime + '--text', compColor.prime]">
              <validation-provider tag="div"
                                   :name="path + '.kuerzel.' + index"
                                   :ref="path + '.kuerzel.' + index"
                                   rules=""
                                   v-slot="{}">
                <span class="layout-row layout-align-start-center py-1 px-2">
                  <strong class="mr-1">{{ getNameOfComplication(index) }}</strong>
                  <v-icon class="ml-3 white--text" style="opacity: 0.6" size="20" @click="deleteKuerzel(index)" :disabled="isDisabled">mdi-close-circle</v-icon>
                </span>
              </validation-provider>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- ICD10-Code -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_OP_COMPLICATIONS_NOT_IN_LIST')"
                        class="px-2"
                        :disabled="isDisabled">
        <div class="layout-column flex-100">
          <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
            <lx-btn :disabled="isDisabled || !!model.komplikation_nein_oder_unbekannt"
                    icon="add_circle"
                    :color="compColor.primeColor"
                    :iconColor="'white'"
                    :tooltip="$t('FORMS_DIVERSE.MODULE_OP_ADD_NEW_COMPLICATION_CODE')"
                    :label="$t('FORMS_DIVERSE.MODULE_OP_ADD_NEW_COMPLICATION_CODE')"
                    iconSize="21"
                    :width="'auto'"
                    :height="35"
                    classes="text-none"
                    @click="addICDElement()"
            ></lx-btn>
          </div>

          <v-divider class="mb-1 mx-2" v-bind:style="{'border-color':compColor.lightDivider}" v-if="model && model.icd && model.icd.length > 0"></v-divider>

          <div :key="index" v-for="(item, index) in model.icd"
               class="layout-row pa-0 mx-2 my-2"
               :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
               style="border-radius:4px;"
               :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

            <div class="layout-row layout-wrap flex px-3">
              <div class="flex-gt-sm-25 flex-100 px-2 py-3">
                <validation-provider tag="div"
                                     :name="path + '.icd.' + index + '.code'"
                                     :ref="path + '.icd.' + index + '.code'"
                                     rules="required|icd10_code_OP_auto_complete"
                                     v-slot="{ errors }">
                  <lx-autocomplete
                    :label="$t('FORMS_DIVERSE.ICD_CODE') + ' *'"
                    v-model="item.code"
                    :error="errors[0]"
                    @search-method="getDataForAutocomplete"
                    @input="setICD10Code"
                    :disabled="isDisabled"
                    :dense="denseFields"
                    :index="index"
                    class="mb-0"
                    :hint="$t('FORMS_DIVERSE.MODULE_OP_CODE_HINT')"
                    :persistent_hint="true"
                    :results="resultSearchModel">
                    <template v-slot="slotProps">
                      <div class="layout-row">
                        <div style="width: 100px;border-radius: 4px;" class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                          <h3>
                            <lx-text-highlight :text="slotProps.lineItem.code" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                          </h3>
                        </div>
                        <div class="flex">
                    <span class="body-2">
                      <lx-text-highlight :text="slotProps.lineItem.description" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                    </span>
                        </div>
                      </div>
                    </template>
                  </lx-autocomplete>
                </validation-provider>
              </div>

              <div class="flex-gt-sm-25 flex-100 px-2 py-3">
                <validation-provider tag="div"
                                     :name="path + '.icd.' + index + '.version'"
                                     :ref="path + '.icd.' + index + '.version'"
                                     rules="required"
                                     v-slot="{ errors }">
                  <v-select
                    :color="compColor.primeColor"
                    :label="$t('FORMS_DIVERSE.ICD_CODE_VERSION') + ' *'"
                    v-model="item.version"
                    :items="ICD_VersionTypes"
                    outlined
                    class="mb-0"
                    @change="resetICD10Code(index)"
                    :disabled="isDisabled"
                    :persistent-hint="true"
                    :hint="$t('FORMS_DIVERSE.CODE_VERSION_HINT')"
                    :dense="denseFields"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-on="on"
                                   :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                        <v-list-item-content class="py-0">
                          <label style="cursor:pointer;"
                                 :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                 class="lighten-4 text--darken-2">{{ item.text }}</label>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
              </div>

              <div class="flex-gt-sm-50 flex-100 px-2 py-3">
                <validation-provider tag="div"
                                     :name="path + '.icd.' + index + '.description'"
                                     :ref="path + '.icd.' + index + '.description'"
                                     rules="trim_string"
                                     v-slot="{ errors }">
                  <long-input
                    :color="compColor.primeColor"
                    :name="path + '.icd.' + index + '.description'"
                    :label="$t('FORMS_DIVERSE.ICD_CODE_TEXT')"
                    v-model="item.description"
                    :disabled="isDisabled"
                    :hide-details="!errors || errors.length <= 0"
                    class="mb-0"
                    :dense="denseFields"
                    :error="errors[0]"
                  ></long-input>
                </validation-provider>
              </div>
            </div>

            <div class="layout-column layout-align-center-center px-3"
                 :class="{'grey lighten-2': !compColor.isInDarkMode}"
                 :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
              <lx-btn @click="deleteComplication('icd', index, path + '.icd.' + index + '.description')"
                      :color="compColor.primeColor"
                      :iconColor="'white'"
                      iconSize="21"
                      :width="35"
                      :height="35"
                      :disabled="isDisabled" icon="delete_forever"></lx-btn>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'
import LxAutocomplete from '../../lx_auto_complete/LxAutocomplete'

export default {
  name: "OpKomplikationen",
  mixins: [metaData, utils],
  components: {
    LxAutocomplete
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        kuerzel: {},
        icd: []
      })
    },
    path: {
      type: String
    },
    addNewItem: {
      type: Function
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: {
        kuerzel: {},
        icd: []
      },
      resultSearchModel: {},
      OP_KomplikationTypes: null,
      ICD_VersionTypes: null,
      selectedComplicationType: null
    }
  },
  created () {
    this.OP_KomplikationTypes = lodash.cloneDeep(this.formsMetaData.OP_KomplikationTypes)
    this.ICD_VersionTypes = this.filterVersions('icd10')
  },
  methods: {
    /**
     * Validate op complications separately after changing inputs in kuerzel, icd or radio-group
     */
    validateComplication () {
      this.$refs[this.path].validate()
    },

    /**
     * Add new element to list of icd and validate complications
     */
    addICDElement () {
      this.addNewItem(this.path + '.icd', {})
      this.validateComplication()
    },

    /**
     * Add kuerzel after selection from autocomplete
     *
     * @param value The selected property e.g. ABS
     */
    addKuerzel (value) {
      this.$set(this.model.kuerzel, value, true)
      // clear selection list, selected property must be deleted from list
      this.getClearedListOfOPComplications()

      this.$nextTick(() => {
        // trigger auto save by setting dirty-flag of kuerzel manually
        if (this.validationRef.fields[this.path + '.kuerzel']) {
          this.validationRef.fields[this.path + '.kuerzel'].changed = true
        }

        // reset value in auto-complete
        this.selectedComplicationType = null
        // trigger validation of complete complication to show error, if no element is selected
        this.validateComplication()
      })
    },

    /**
     * Modify selection list of auto-complete after adding or deleting new element or loading form
     */
    getClearedListOfOPComplications () {
      this.OP_KomplikationTypes = lodash.cloneDeep(this.formsMetaData.OP_KomplikationTypes)

      if (this.model.kuerzel && Object.keys(this.model.kuerzel).length > 0) {
        this.OP_KomplikationTypes = this.OP_KomplikationTypes.filter(elem => Object.keys(this.model.kuerzel).indexOf(elem.value) < 0)
      }
    },

    /**
     * Return description text for complication to show in chips in view
     *
     * @param value The value in kuerzel-object e.g. ABS
     * @returns {*|string}
     */
    getNameOfComplication (value) {
      const name = this.formsMetaData.OP_KomplikationTypes.find(elem => elem.value === value)

      return name ? name.text : ''
    },

    /**
     * Delete selected kuerzel form object and validate complications
     *
     * @param field
     */
    deleteKuerzel (field) {
      this.$delete(this.model.kuerzel, field)

      // adapt selection list, selected property must be added to list
      this.getClearedListOfOPComplications()

      this.$nextTick(() => {
        if (this.validationRef.fields[this.path + '.kuerzel']) {
          this.validationRef.fields[this.path + '.kuerzel'].changed = true
        }

        // trigger validation of complete complication to show error, if no element is selected
        this.validateComplication()
      })
    },

    /**
     * Reset selected radio-button and trigger dirty flag of validator for save
     */
    resetRadioButtons (field) {
      this.$set(this.model, field, null)
      this.validationRef.fields[this.path + '.' + field].changed = true
      this.validateComplication()
    },

    /**
     * Reset all complications after setting one of the komplikation_nein_oder_unbekannt-values
     *
     * @param value The value of model.komplikation_nein_oder_unbekannt
     */
    resetComplicationTypes (value) {
      this.$set(this, 'model', {komplikation_nein_oder_unbekannt: value, kuerzel: {}, icd: []})
      this.validationRef.fields[this.path + '.komplikation_nein_oder_unbekannt'].changed = true
    },

    /**
     * Delete ICD10-code and text after changing version
     *
     * @param index The index of disease-element
     */
    resetICD10Code (index) {
      this.$delete(this.model.icd[index], 'code')
      this.$delete(this.model.icd[index], 'description')
    },

    /**
     * Get list of icd10 codes via regex in auto-complete
     *
     * @param data The search string for complication
     * @param index The index of element in icd array
     */
    getDataForAutocomplete (data, index) {
      if (data && this.model.icd[index].code && data !== this.model.icd[index].code) {
        this.$set(this.model.icd[index], 'description', undefined)
        this.$set(this.model.icd[index], 'version', undefined)
      }

      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      let config = {
        opts: {
          limit: 30
        },
        query: {
          searchValue: data
        }
      }

      // if icd-10 version is set, send it to backend
      const foundVersion = this.ICD_VersionTypes.find(elem => elem.value === this.model.icd[index].version)

      if (foundVersion?.misdValue) {
        config.query.version = foundVersion.misdValue
      }

      this.$http.get('/icd10?config=' + JSON.stringify(config) + '&filtered=op')
        .then(res => {
          this.resultSearchModel = {
            result: res.data.items,
            count: res.data.count,
            version: res.data.version,
            index: index
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Set icd10 value via list form auto complete
     *
     * @param data The selected object from list of proposed icd10-codes
     * @param index The index of element in icd array
     */
    setICD10Code (data, index) {
      if (data && data.code) {
        const foundVersion = this.ICD_VersionTypes.find(elem => elem.misdValue === this.resultSearchModel.version)
        const version = foundVersion?.value ? foundVersion?.value : this.formsMetaData.ICD10_Version

        this.$set(this.model.icd[index], 'code', data.code)
        this.$set(this.model.icd[index], 'description', data.description)
        this.$set(this.model.icd[index], 'version', version)
      } else {
        if (!this.model?.icd[index]?.code || typeof data === 'string' || (this.validationRef.errors && this.validationRef.errors[this.path + '.icd.' + index + '.code'] && this.validationRef.errors[this.path+ '.icd.' + index + '.code'].length > 0)) {
          // nextTick is necessary to trigger watcher in autocomplete on the right way
          this.$nextTick(() => {
            // delete input of icd10, if not selected from result list
            if (typeof data === 'string') this.$set(this.model.icd[index], 'code', null)
          })

          this.$set(this.model.icd[index], 'description', undefined)
        }
      }
    },

    /**
     * Delete selected element of previous diseases and trigger validator for saving
     */
    deleteComplication (path, index, field) {
      this.deleteItem(path, index)
      this.validationRef.fields[field].changed = true
      this.validateComplication()
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
          this.model.kuerzel = this.model.kuerzel || {}

          // adapt selection list of auto complete
          this.getClearedListOfOPComplications()
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.v-input--checkbox .v-input--selection-controls__input {
  margin-right: 0;
}
</style>
